import React, { useEffect, useState } from "react";
import "../App.css";
import { useForm } from "react-hook-form";
import axios from ".././axios-interceptor";
import { ADMIN_ROLE, base_url, CRYPTO_SECRET_KEY, TURNSTILE_SITEKEY } from "../utilities";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { ResetPassword } from "../BusinessFlow/BusinessLogin";
import {  Modal } from "react-bootstrap";
import { Turnstile} from '@marsidev/react-turnstile';
import Cookies from 'js-cookie';
import { decrypt } from "../utils";

const AdminLoginPage = (props) => {
  const [disabled, setDisabled] = useState(false);
  const [canSubmit, setCanSubmit] = useState(false);

  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({});
  const [modalShow, setModalShow] = React.useState(false);
  const handleLogin = () => {};
  
  const [showPWDExpModal, setShowPWDExpModal] = useState(false)


const handlePWDExpiry=()=>{
setShowPWDExpModal(false)
  setModalShow(true)
}

const handleCloseExpModal=()=>{
  setShowPWDExpModal(false)
}
 
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  useEffect(() => {}, []);
  const onSubmit = (data) => {
    if (data !== null && data !== "") {
      let hashedpassword = CryptoJS.AES.encrypt(
        data.password,
        CRYPTO_SECRET_KEY
      ).toString();
      let hashedemail = CryptoJS.AES.encrypt(
        data.email,
        CRYPTO_SECRET_KEY
      ).toString();
      let hashedrole = CryptoJS.AES.encrypt(
        ADMIN_ROLE.toString(),
        CRYPTO_SECRET_KEY
      ).toString();
      axios
        .post(base_url + "loginUser", {
          email_id: hashedemail,
          password: hashedpassword,
          role: hashedrole,
        })
        .then((res) => {
          if(decrypt(res.data.message)==="password expired"){
            setShowPWDExpModal(true)
          }
          const { access_token, auth_refresh_token } = res.data;
          setLoginData(res.data.result);
          let user_id = res.data.result.user_id;
          let user_name = res.data.result.user_name;
          let msg=decrypt(res.data.message)
         
          if (msg == "Invalid") {
            toast.error("Invalid Email or Password", {
              toastId: 5,
            });
          }  
          else if (res.data.result.role_code != ADMIN_ROLE) {
            toast.error("Please enter valid credentials", {
              toastId: 2,
            });
          } else {
            setDisabled(true);
            setTimeout(() => {
              //business session removing
              Cookies.remove("User_Accesstoken_Business");
              Cookies.remove("User_Refreshtoken_Business");
              // investor session removing
              Cookies.remove("User_Accesstoken_Investor");
              Cookies.remove("User_Refreshtoken_Investor");
              // admin login never sets role_code: drop any stale auditor/business/investor value
              Cookies.remove("role_code");
              //creating the admin session below
              Cookies.set("admin_user_name", user_name, { expires: 7 });
              Cookies.set("admin_user_id", user_id, { expires: 7 });
              Cookies.set("User_Accesstoken", access_token, { expires: 7 });
              Cookies.set(
                "User_Refreshtoken_Admin",
                auth_refresh_token, { expires: 7 }
              );
              Cookies.set("User_Accesstoken_Admin", access_token, { expires: 7 });
              userSession();
              navigate("/admindashboard");
            }, 800);
          }
        });
    }
  };


  const userSession = () => {
    setInterval(() => {
      axios
        .post(base_url + "user/refreshtoken", {
          auth_refresh_token: Cookies.get("User_Refreshtoken_Admin"),
        })
        .then((res) => {
          Cookies.set(
            "User_Accesstoken_Admin",
            res.data?.access_token
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }, 50 * 60 * 1000);
  };
  return (
    <div className="admin_bg justify-content-center d-flex">
      {!canSubmit ?<div className="d-flex flex-column justify-content-center align-items-cneter">
     <h5 className="text-white">Verifying you are human. This may take a few seconds.</h5>
     <Turnstile
              className="align-self-center d-flex mt-3"
                options={{
                  action: 'submit-form',
                  theme: 'light'
                }}
                id='turnstile-1'
                siteKey={TURNSTILE_SITEKEY}
                onSuccess={() => setTimeout(()=>setCanSubmit(true),2000)}
              />
              </div> :
               <div className="d-flex  align-items-center">
        <div className="">
          <h4 className="mb-3 d-flex justify-content-center ">
            <img
              className="img-fluid "
              style={{ height: "100px" }}
              src="./images/New_white_blue_brand_name.svg"
              alt="true"
            />
          </h4>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group mb-3 admin_login_label">
              <label htmlFor="email">
                Email<span className=""> *</span>
              </label>
              <input
                {...register("email", { required: true })}
                id="email"
                type="text"
                className="form-control rounded px-4 py-3 border-0"
                placeholder="Please enter your Email"
              />
              {errors.email && (
                <span style={{ color: "#fd5a5a" }}>Please enter an Email </span>
              )}
            </div>
            <div className="form-group admin_login_label">
              <label htmlFor="password">
                Password<span className=""> *</span>
              </label>
              <input
                {...register("password", { required: true })}
                id="password"
                type="password"
                className="form-control rounded px-4 py-3 border-0"
                placeholder="Please enter your password"
              />
              <div className="d-flex justify-content-between">
                {errors.password && (
                  <span style={{ color: "#fd5a5a" }}>Enter a password </span>
                )}
                <span className="forgot_pwd" onClick={() => setModalShow(true)}>
                  Reset Password?
                </span>
              </div>
            </div>

            <ResetPassword modalShow={modalShow} setModalShow={setModalShow} />
            
        <PassWordExpiryModal
          showPWDExpModal={showPWDExpModal}
          handleCloseExpModal={handleCloseExpModal} 
          handlePWDExpiry={handlePWDExpiry}
          />
            <div className="d-grid mt-2 align-items-center">
             
              <button
                className=" gray_btn_lg mt-4"
                disabled={disabled}
                onClick={handleLogin}
              >
                Login
              </button>
              
            </div>
          </form>
        </div>
      </div>}
    </div>
  );
};

export default AdminLoginPage;


 

export const PassWordExpiryModal = (props) => {
  return (
    <Modal 
    keyboard={false}
    show={props.showPWDExpModal} 
    onHide={props.handleCloseExpModal}
    backdrop="static"
              centered
              aria-labelledby="contained-modal-title-vcenter"
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">Password Expired</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center pt-4 pb-5 lh-2">
              Your password has expired.

                  Please <p className="text-decoration-underline Cpointer" onClick={props.handlePWDExpiry}>click here</p> to reset your password.
              </Modal.Body>

            </Modal>

  );
};
